import { css } from '@emotion/react';
import styled from '@emotion/styled';
import COLORS3 from '@zola/zola-ui/src/styles/emotion/colors3';
import H from '@zola/zola-ui/src/typography/Headings';
import MEDIA_QUERY_V2 from '@zola/zola-ui/src/styles/emotion/mediaQueryV2';
import SPACING from '@zola/zola-ui/src/styles/emotion/spacing';
import FONT from '@zola/zola-ui/src/styles/emotion/fonts';
import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';

const max1920 = css`
  max-width: 1920px;
  width: 100%;
  ${MEDIA_QUERY_V2.DESKTOP_MASSIVE} {
    border-left: 1px solid ${COLORS3.BLACK_030};
    border-right: 1px solid ${COLORS3.BLACK_030};
  }
`;

export const StyledHTitle3 = styled(H.Title3)`
  text-align: center;
  margin: auto;
  padding: 56px 0;

  ${MEDIA_QUERY_V2.MOBILE} {
    padding: ${SPACING.S32} 0;
    max-width: 400px;
  }

  ${MEDIA_QUERY_V2.TABLET} {
    max-width: 600px;
  }
`;

export const CtaSection = styled.section`
  border-bottom: 1px solid ${COLORS3.BLACK_030};
  ${max1920};
  width: 100%;
  padding: 56px ${SPACING.S24};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  ${MEDIA_QUERY_V2.EXCLUDE_MOBILE} {
    padding: 64px 56px;
    align-items: center;
  }
`;

export const CtaText = styled.span`
  ${FONT.textSizeCompact(FONT.FONT_SIZE_LARGER)};
  ${MEDIA_QUERY_V2.EXCLUDE_MOBILE} {
    text-align: center;
  }
  ${MEDIA_QUERY_V2.TABLET} {
    ${FONT.textSizeCompact('42px')};
  }
  ${MEDIA_QUERY_V2.DESKTOP} {
    ${FONT.textSizeCompact(FONT.FONT_SIZE_SEMI_HUGE)};
  }
  ${MEDIA_QUERY_V2.DESKTOP_XL} {
    ${FONT.textSizeUltraCompact('64px')};
  }
  letter-spacing: -0.04em;
`;

export const CtaButton = styled(ButtonV3)`
  margin-top: ${SPACING.S16};
  ${MEDIA_QUERY_V2.TABLET} {
    margin-top: ${SPACING.S24};
  }
  ${MEDIA_QUERY_V2.DESKTOP} {
    margin-top: ${SPACING.S32};
  }
`;

export const Highlight = styled.span`
  font-family: ${FONT.FONT_FAMILY_NEW_SPIRIT};
`;
